import { Pipe, PipeTransform } from '@angular/core';

import { ToOrdinalNumber, ToPlainText } from '@empathy/global/functions';
import { QuestionOption, QuestionType, RatingType } from '@empathy/survey/base';

import { Question } from '../models/question.model';

@Pipe({
  name: 'rankTextByType',
  pure: true
})
export class RankTextByType implements PipeTransform {
  transform(option: QuestionOption, question: Question): string {
    switch (question.type) {
      case QuestionType.RankSort: {
        return question.ratingType === RatingType.numeric ? ToOrdinalNumber(+option.value) : ToPlainText(option.text);
      }
      case QuestionType.Ranking: {
        return ToOrdinalNumber(+option.value);
      }
      default:
        return ToPlainText(option.text);
    }
  }
}
